import { get_projects } from '../../../../Services/project'

//Função que traz os dados do banco de dados
export const get = () =>{
    return[(dispatch,getState)=>{
        
        const order = getState().project.order
        const th = getState().project.th
        const qtd_per_page = getState().project.qtd_per_page
        const pesquisa = getState().project.pesquisa || ''
        const page = getState().project.page   
        const type = getState().project.type.value || ''
        const area = getState().project.area.value || ''
        const manager = getState().project.manager.value || ''
        const coordinator = getState().project.coordinator.value || ''
        const status = getState().project.status.value || ''


        get_projects(page,qtd_per_page,order,th,pesquisa,type,area,manager,coordinator,status)
        .then(resp=>dispatch({type:'Projects', payload:resp.data}))

    }]
}

//Função que ordena as colunas
export const order = (coluna) => {
    return [(dispatch,getState)=>{
        const asc = getState().project.asc
      
        if(asc === true){
            dispatch({type:'GetProject_Desc', desc:true, asc:false,order:'desc',th:coluna})
            
        }if(asc === false){
            dispatch({type:'GetProject_Asc', asc:true, desc:false,order:'asc',th:coluna})
            
        }
     
    },get(1)]    
}

export const change_qtd_per_page = event => {
    return[{
        type:'qtd_per_page_project',
        payload:event.target.value
    },get(1)]
}

export const changePesquisa = event => {
    return[{
        type:'pesquisaProject',
        payload:event.target.value
    }]
}

export const clearPesquisa = event => {
    return[{
        type:'clearPesquisaProject',
        payload:''
    },get(1)]
}

export const changePage = page => {
    return[{
        type: 'changePageProject',
        payload: page
    },get()]
}

export const search = () => {
    return [
        (dispatch, getState) => {
            const pesquisa = getState().project.pesquisa || ''
            if(pesquisa){
                return dispatch({type:'changePageProject', payload:1})
            }
        }, get()
    ]
}